import { useEffect } from 'react';

import { useIntlStore } from '@dcentralexpedientedigital/fe-shared/stores/intl-store';

import { isValidLocale } from '../utils/language';

// This hook is used to keep HTML lang consistent with the current locale
export const useHtmlLang = () => {
    const locale = useIntlStore((state) => state.locale);

    useEffect(() => {
        if (locale && isValidLocale(locale)) {
            document.documentElement.lang = locale.toLowerCase();
        }
    }, [locale]);
};
